import script from "./VoiceRecognition.vue?vue&type=script&setup=true&lang=js"
export * from "./VoiceRecognition.vue?vue&type=script&setup=true&lang=js"

import "./VoiceRecognition.vue?vue&type=style&index=0&id=649fc32c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-649fc32c"]])

export default __exports__